import { QueryKey } from "@tanstack/react-query";

export const companyQueryKeys = {
  all: () => ["company"] as QueryKey,
};
